// Api
import { useUpdatehealthyPerkByDayMutation } from "rtkQuery/query/healthyPerkAPI";
// Hooks
import { useNotification } from "hooks";
// Types
import {
  DayEnum,
  GetHealthyPerkResponseDto,
  UpdateHealthyPerkRequestDto,
} from "types/healthyPerk";
import { CustomerMenuProduct } from "types/customers";
// Utils
import { errorHandler } from "utils/errorHandler";

export const useUpdatePerksData = (
  healthyPerksData: GetHealthyPerkResponseDto,
) => {
  const { openNotification } = useNotification();

  const [updatePerks, { isLoading: updatePerksIsLoading }] =
    useUpdatehealthyPerkByDayMutation();

  const handleCreatePerk = async (
    day: DayEnum,
    product: CustomerMenuProduct,
    tiers: string[],
  ) => {
    try {
      const data = healthyPerksData?.data[day] || [];

      const payload: UpdateHealthyPerkRequestDto = {
        data: { day, products: [...data, { product, tiers }] },
      };
      await updatePerks(payload).unwrap();

      openNotification({
        type: "success",
        message: "Healthy Perk created successfully",
      });

      return { result: true };
    } catch (error) {
      errorHandler({ error, openNotification });

      return { result: false };
    }
  };

  const handleUpdatePerk = async (
    id: string,
    day: DayEnum,
    product: CustomerMenuProduct,
    tiers: string[],
  ) => {
    try {
      const data =
        healthyPerksData?.data?.[day]?.filter(
          perkItem => perkItem?.id !== id,
        ) || [];

      const payload: UpdateHealthyPerkRequestDto = {
        data: { day, products: [...data, { id, product, tiers }] },
      };
      await updatePerks(payload).unwrap();

      openNotification({
        type: "success",
        message: "Healthy Perk updated successfully",
      });

      return { result: true };
    } catch (error) {
      errorHandler({ error, openNotification });
      return { result: false };
    }
  };

  const handleDeletePerk = async (id: string, day: DayEnum) => {
    try {
      const data =
        healthyPerksData?.data?.[day]?.filter(
          perkItem => perkItem?.id !== id,
        ) || [];

      const payload: UpdateHealthyPerkRequestDto = {
        data: { day, products: [...data] },
      };
      await updatePerks(payload).unwrap();

      openNotification({
        type: "success",
        message: "Healthy Perk deleted successfully",
      });

      return { result: true };
    } catch (error) {
      errorHandler({ error, openNotification });

      return { result: false };
    }
  };

  return {
    updatePerksIsLoading,
    handleUpdatePerk,
    handleCreatePerk,
    handleDeletePerk,
  };
};
